module.exports = __webpack_public_path__ + "static/media/KGOG.07d659b7.png";